import PropTypes from 'prop-types'
export const types = {
  page: PropTypes.shape({
    getButton: PropTypes.func,
    getChannelParameters: PropTypes.func,
    getComponent: PropTypes.func,
    getContent: PropTypes.func,
    getDocument: PropTypes.func,
    getLocale: PropTypes.func,
    getMeta: PropTypes.func,
    getTitle: PropTypes.func,
    getUrl: PropTypes.func,
    getVersion: PropTypes.func,
    getVisitor: PropTypes.func,
    getVisit: PropTypes.func,
    isPreview: PropTypes.func,
    rewriteLinks: PropTypes.func,
    sync: PropTypes.func,
    toJSON: PropTypes.func,
  }),
  component: PropTypes.shape({
    getId: PropTypes.func,
    getMeta: PropTypes.func,
    getModels: PropTypes.func,
    getUrl: PropTypes.func,
    getName: PropTypes.func,
    getParameters: PropTypes.func,
    getProperties: PropTypes.func,
    getChildren: PropTypes.func,
    getComponent: PropTypes.func,
    getComponentById: PropTypes.func,
  }),
}
